import { render, staticRenderFns } from "./teamWidget.vue?vue&type=template&id=a196d45c&"
import script from "./teamWidget.vue?vue&type=script&lang=js&"
export * from "./teamWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports